import React, { useEffect, useState } from "react";
import "../../styles/admins/inventory.css";
import "../../styles/admins/companies.css";
import AddCompany from "./add_company";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { MdDangerous, MdVerifiedUser } from "react-icons/md";
import Swal from "sweetalert2";
import { FiSearch } from "react-icons/fi";

function AdminCompanies(props) {
  const [toggleAdd, setToggleAdd] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [editComp, setEditComp] = useState({});
const [searchTerm, setSearchTerm] = useState("");
const [statusFilter, setStatusFilter] = useState(""); 

  function addProductToggler() {
    setToggleAdd(!toggleAdd);
  }

  // useEffect(() => {
    
  //   getCompanies();
  // }, [props]);
  
  useEffect(() => {
    
    getCompanies();
  }, []);



  // const getCompanies = async () => {
  //     try {
  //       const storedCompany = localStorage.getItem("companies");

  //       if (storedCompany) {
  //         setCompanies(JSON.parse(storedCompany));
  //       } else {
  //         const response = await axios.get(
  //           "https://api.dectwinservices.com/api/companies"
  //         );
  //         setCompanies(response.data);
  //         localStorage.setItem("companies", JSON.stringify(response.data));
  //       }
  //     } catch (e) {
  //       props.handleToast({
  //         toastMsg:
  //           "Something went wrong! Please Refresh page or check internet.",
  //         toastColor: "#FF0000",
  //       });
  //     }
  //   };

const getCompanies = async () => {
  try {
    const response = await axios.get(
      "https://api.dectwinservices.com/api/companies"
    );

    setCompanies(response.data);

    localStorage.setItem(
      "companies",
      JSON.stringify(response.data)
    );
  } catch (e) {
    props.handleToast({
      toastMsg:
        "Something went wrong! Please Refresh page or check internet.",
      toastColor: "#FF0000",
    });
  }
};


  const exportToExcel = () => {
    if (!companies || companies.length === 0) {
      console.error("No data to export.");
      return;
    }

    // Define the columns for the Excel file
    const formattedData = companies.map((item) => ({
      "Company Name": item.company_name,
      "Company ID": item.comp_id,
      Location: item.location,
      Contact: item.contact,
      Email: item.email,
      // "Technician": item.technician_id,
      // "Location": item.location,
    }));

    // Create a new worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Products");

    // Convert workbook to a binary Excel file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Create a Blob and trigger download
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `Companies.xlsx`);
  };

  const handleCompanyStatus = async (company) => {
  const isActive = company.is_active === 0;

  const result = await Swal.fire({
    title: isActive
      ? "Deactivate Company?"
      : "Activate Company?",
    text: isActive
      ? "Are you sure you want to deactivate this company ?"
      : "Are you sure you want to activate this company?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
      await axios.put("https://api.dectwinservices.com/api/update-status", {
        company_id: company.id,
        is_active: isActive ? 1 : 0,
      });

    

      Swal.fire({
        icon: "success",
        title: isActive
          ? "Company Deactivated"
          : "Company Activated",
        timer: 1500,
        showConfirmButton: false,
      });

      
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
      });
    }
  }

    await getCompanies();
};


const filteredData = companies
  .filter((item) => {
    // STATUS FILTER
    if (statusFilter === "active") return item.is_active === 0;
    if (statusFilter === "inactive") return item.is_active === 1;
    return true;
  })
  .filter((item) =>
    item.company_name
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase())
  );
  
  return toggleAdd ? (
    <AddCompany
      editComp={editComp}
      toggler={addProductToggler}
      handleToast={props.handleToast}
      handleLoading={props.handleLoading}
      closeLoading={props.closeLoading}
    />
  ) : (
     <section className="px-32">
      <div className="d-md-flex justify-between">
        <div className="d-flex">

          <i className="bx bxs-buildings" style={{ fontSize: "24px" }}></i>
          <p className="fw-bolder fs-big">&nbsp;Companies Overview</p>
        </div>
    <div className="d-md-flex d-sm-flex">

        
           <div className="my-2 px-1">   
     <button
            className="add-btn"
            style={{ background: "#00AA00" }}
            onClick={exportToExcel}
          >
            <i className="bx bxs-download" style={{ fontSize: "22px" }}></i>
            &nbsp; Export to Excel
          </button>
          </div>

      <div className="my-2 px-1">   
          <button
            className="add-btn"
            onClick={() => {
              setEditComp({});
              addProductToggler();
            }}
          >
            <i className="bx bxs-plus-circle" style={{ fontSize: "22px" }}></i>
            &nbsp; Add Company
          </button>
          </div>
        </div>
      </div>

<div className="row align-items-center mb-3">

  {/* LEFT - SEARCH */}
  <div className="col-md-4">
      <div className="input-icon bg-white">
        <i className="bx bxs-search"></i>


      <input
        type="text"
        className="form-control p-2"
        placeholder="Search by name"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  </div>

  {/* RIGHT - BUTTONS */}
  <div className="col-md-8 d-flex justify-content-end gap-2">
    
    <button
      className={`btn ${
        statusFilter === "active" ? "btn-success" : "btn-outline-success"
      }`}
      onClick={() => setStatusFilter("active")}
    >
      Active
    </button>

    <button
      className={`btn ${
        statusFilter === "inactive" ? "btn-danger" : "btn-outline-danger"
      }`}
      onClick={() => setStatusFilter("inactive")}
    >
      Inactive
    </button>

  </div>

</div>

         <div className="bg-white table-responsive rounded-3">
        <table className="table w-100">
                   <thead className="bg-grey">
          
              <th className="p-2">Company ID</th>
              <th className="p-2">Company Name</th>
              <th className="p-2">Location</th>
              <th className="p-2">Contact</th>
              <th className="p-2">Email</th>
              {/* <th className="p-2">Technician</th> */}
                  <th   className="p-2 text-center">
                <i className="bx bxs-cog rounded-circle bg-grey p-0"></i>
              </th>
          </thead>
              {filteredData.map((com, index) => (
                <tr key={index}>
                  <td className="p-2">{com.comp_id}</td>
                  <td className="p-2">{com.company_name}</td>
                  <td className="p-2">{com.location}</td>
              <td className="p-2">{com.contact}</td>
                  <td className="p-2">{com.email}</td>
                
                  <td className="p-2">
                        <div className="d-flex justify-content-center align-items-center gap-2">
                                             <i
                      title="Edit Product"
                      style={{ fontSize: "24px", cursor: "pointer" }}
                      className="bx bxs-edit"
                      onClick={() => {
                        setEditComp(com);
                        addProductToggler();
                      }}
                    ></i> 

                 
                   {com.is_active === 0 ? (
  <MdDangerous
    className="text-danger  gap-3"
    cursor="pointer"
    size={22}
    title="Deactivate Company"
    onClick={() => handleCompanyStatus(com)}
  />
) : (
  <MdVerifiedUser
    className="text-success  gap-3"
    cursor="pointer"
    size={22}
    title="Activate Company"
    onClick={() => handleCompanyStatus(com)}
  />
)}
                        </div>
 
                  </td>
                </tr>
              ))}
              </table>
      </div>
    </section>
  );
}

export default AdminCompanies;
